export default [
    {
        name: '🍝 FB',
        tags: ['eat'],
        products: [{
            name: 'Restaurant',
            ratings: [{
                source: 'FB',
                normalized_rating: 4,
                canonical_rating: '👍',
            }]
        }],
    },
    {
        name: '🍝 Wro',
        tags: ['eat'],
        products: [{
            name: 'Restaurant',
            ratings: [{
                source: 'FoodiesWro',
                normalized_rating: 4,
                canonical_rating: '👍',
            }]
        }],
    },
    {
        name: '🍝 WPK',
        tags: ['eat'],
        products: [{
            name: 'Restaurant',
            ratings: [{
                source: 'WPK',
                normalized_rating: 4,
                canonical_rating: '👍',
            }]
        }],
    },
    {
        name: '🍝 MaciejJe',
        tags: ['eat'],
        products: [{
            name: 'Restaurant',
            ratings: [{
                source: 'MaciejJe',
                normalized_rating: 4,
                canonical_rating: '👍',
            }]
        }],
    },


    {
        name: '🍰 FB',
        tags: ['sweet'],
        products: [{
            name: 'Cukiernia',
            ratings: [{
                source: 'FB',
                normalized_rating: 4,
                canonical_rating: '👍',
            }]
        }],
    },
    {
        name: '🍰 Wro',
        tags: ['sweet'],
        products: [{
            name: 'Cukiernia',
            ratings: [{
                source: 'FoodiesWro',
                normalized_rating: 4,
                canonical_rating: '👍',
            }]
        }],
    },
    {
        name: '🍰 WPK',
        tags: ['sweet'],
        products: [{
            name: 'Cukiernia',
            ratings: [{
                source: 'WPK',
                normalized_rating: 4,
                canonical_rating: '👍',
            }]
        }],
    },
    {
        name: '🍰 MaciejJe',
        tags: ['sweet'],
        products: [{
            name: 'Cukiernia',
            ratings: [{
                source: 'MaciejJe',
                normalized_rating: 4,
                canonical_rating: '👍',
            }]
        }],
    },
]
